
import React, { useEffect, useState } from 'react';
import styles from '../../../../styles/modules/Waiver.module.css'
import CustomCheckbox from '../../../CustomComponents/CustomCheckbox/CustomCheckbox';
import { CiMenuKebab } from 'react-icons/ci';
import { Alert, Menu, MenuItem, TextField } from '@mui/material';
import CustomDialog from '../../../CustomComponents/CustomDialog/CustomDialog.jsx'
import { FormTemplateAPI } from '../../../../api/FormTemplateAPI.js';
import { useSelector } from 'react-redux';
import Loader from '../../../../component/Loader.jsx';
import { AiTwotoneDelete } from 'react-icons/ai';
import { MdDeleteOutline, MdOutlineModeEditOutline } from 'react-icons/md';
import { Privileges } from '../../../../util/PrivilegeConstants.js';
import * as Yup from 'yup'
import { isClubOwner } from '../../../../util/UserRoles.js';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../../redux/reducer/rootReducer.js';

const initialvalue = {
  name: '',
  desc: ''
}

const validationObj = Yup.object({
  name: Yup.string().required("Waiver Name is required").max(300, "Waiver Name must not exceed 300 characters."),
  desc: Yup.string().required("Waiver Description is required").max(2000, "Waiver Description must not exceed 2000 characters."),
})

const Waivers = ({ formTemplateId, privileges, formtemplateStatus }) => {
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const userInfo = useSelector((store) => store.user.userInfo);
  const [openDialog, setOpenDialog] = useState({ isOpen: false, isEdit: false });
  const [waiverData, setWaiverData] = useState(initialvalue);
  const [waiverList, setWaiverList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const dispatch = useDispatch();


  const collectData = (event) => {
    const { name, value } = event.target;
    setWaiverData({ ...waiverData, [name]: value })
  };
  const handleAddWaiver = async () => {
    try {
      await validationObj.validate(waiverData, { abortEarly: false });
      setIsLoading(true);
      if (openDialog.isEdit) {
        await FormTemplateAPI.putUpdateWaiver({
          waiverId: waiverData.id,
          name: waiverData.name,
          desc: waiverData.desc
        });
        setWaiverList(waiverList.map(item => item.id === waiverData.id ? { ...item, name: waiverData.name, desc: waiverData.desc } : { ...item }))
      } else {
        const response = await FormTemplateAPI.postCreateWaiver({
          clubId: selectedClub.clubId,
          name: waiverData.name,
          desc: waiverData.desc
        })
        setWaiverList(prev => [...prev, response.Data]);
      }

      setOpenDialog({ isOpen: false, isEdit: false });
      setWaiverData(initialvalue);
    } catch (error) {
      console.log(error);
      if (error?.inner) {
        let errorObj = {}
        error.inner.forEach(err => {
          errorObj[err.path] = err.message;
        })
        setFieldErrors(errorObj)
      }
    } finally {
      setIsLoading(false);
    }
  };
  const findAllWaiver = async () => {
    try {
      setIsLoading(true);
      const response1 = await FormTemplateAPI.getAllWaiver(selectedClub.clubId);
      const response2 = await FormTemplateAPI.getAllAttachedWaiver(formTemplateId);
      const newObj = response1.Data.map(item => (response2.Data.some(obj => obj.id === item.id) ? {
        ...item, isAttach: true
      } : { ...item, isAttach: false }));
      setWaiverList(newObj);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedClub.clubId) {
      findAllWaiver();
    }
  }, [selectedClub.clubId])

  const collectSelectedWaiver = (index, waiver, isAttach) => {
    setWaiverList((prev) => {
      let newObj = [...prev];
      newObj[index] = {
        ...waiver,
        formTemplateId: formTemplateId,
        isAttach: isAttach,
      }
      return newObj;
    })
  };
  const handleAttachWaiverToTemplate = async () => {
    try {
      setIsLoading(true);
      await FormTemplateAPI.postAddWaiverInFormTemplate(waiverList.map(item => ({ waiverId: item.id, formTemplateId: formTemplateId, isAttach: item.isAttach })));
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Waiver updated successfully' }));
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteWaiver = async () => {
    try {
      setIsLoading(true);
      await FormTemplateAPI.deleteWaiver({
        waiverId: waiverData.id,
        clubId: selectedClub.clubId
      })
      setWaiverList(prev => prev.filter(item => item.id !== waiverData.id))
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles['waiver_container']}>
      {isLoading && <Loader />}
      <div className={styles['waiver_header']}>
        <h1>Waivers</h1>
        {(privileges?.MANAGE_WAIVER?.includes(Privileges.CREATE) && (formtemplateStatus === 'IN_PROGRESS' || isClubOwner(userInfo))) &&
          <button type='button' onClick={() => setOpenDialog({ isOpen: true, isEdit: false })} >Add Waiver</button>}
      </div>
      <Alert sx={{
        marginTop: 2, border: '2px solid var(--hoverColorBold)',
        borderRadius: 2,
        '& .MuiAlert-icon': {
          color: 'var(--hoverColorBold)',
        },
      }} variant='outlined' severity='info' >
        Select one or multiple waivers from the list that you want to add to your form template.To add more waivers, click the 'Add Waiver' button above.
      </Alert>
      <div className={styles['waiver_list']}>
        {waiverList?.map((waiver, index) =>
          <div key={index} className={styles['waiver_card']}>
            <div className={styles['waiver_part_1']}>
              <CustomCheckbox onChange={(event) => collectSelectedWaiver(index, waiver, event.target.checked)} checked={waiverList[index]?.isAttach ?? false} />
              <div className={styles['waiver_description']}>
                <h2>{waiver?.name}</h2>
                <p>{waiver?.desc}</p>
              </div>
            </div>
            {(privileges?.MANAGE_WAIVER?.includes(Privileges.MODIFY) && (formtemplateStatus === 'IN_PROGRESS' || isClubOwner(userInfo))) &&
              <CiMenuKebab onClick={(event) => {
                setAnchorEl(event.currentTarget);
                setWaiverData(waiver);
              }} style={{ cursor: 'pointer', fontSize: '1.5rem' }} />}
          </div>
        )}
      </div>
      {(waiverList?.length != 0 && privileges?.MANAGE_WAIVER?.includes(Privileges.MODIFY) && (formtemplateStatus === 'IN_PROGRESS' || isClubOwner(userInfo))) &&
        <div className={styles['waiver_save_btn']}>
          <button onClick={handleAttachWaiverToTemplate} type='button'>Save</button>
        </div>}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => {
          setOpenDialog({ isOpen: true, isEdit: true });
          setAnchorEl(null)
        }
        }><MdOutlineModeEditOutline className={styles['waiver_edit_icon']} />Edit</MenuItem>
        <MenuItem onClick={() => {
          deleteWaiver();
          setAnchorEl(null);
        }}><MdDeleteOutline className={styles['waiver_edit_icon']} />Delete</MenuItem>
      </Menu>
      <CustomDialog
        isOpen={openDialog.isOpen}
        onClose={() => setOpenDialog({ isOpen: false, isEdit: false })}
        onCancel={() => {
          setOpenDialog({ isOpen: false, isEdit: false })
          setWaiverData(initialvalue);
          setFieldErrors({})
        }}
        onSubmit={handleAddWaiver}
        title="Enter Waiver Details"
      >
        <div className={styles['add_waiver_con']}>
          <TextField
            error={fieldErrors['name']}
            helperText={fieldErrors['name'] && fieldErrors['name']}
            className={styles['form_text_field_theme']}
            name='name' fullWidth label="Name"
            value={waiverData.name}
            onChange={collectData}
          />
          <TextField
            error={fieldErrors['desc']}
            helperText={fieldErrors['desc'] && fieldErrors['desc']}
            className={styles['form_text_field_theme']}
            name='desc' fullWidth multiline maxRows={10}
            label="Description"
            value={waiverData.desc}
            onChange={collectData}
          />
        </div>
      </CustomDialog>
    </div>
  )
}

export default Waivers
